import "./App.css";
import { BrowserRouter, Route, Routes } from "react-router";
import { ThemeProvider } from "@emotion/react";
import {
  HomeScreen,
  SignUpScreen,
  SignInScreen,
  KYCDetailsScreen,
  ShortsScreen,
  TripReviewsScreen,
} from "./screens";
import { appTheme } from "./utils";
import BasicDetailsScreen from "./screens/user-basic-details/basic-details-screen";
import BankDetailsScreen from "./screens/bank-details/bank-details-screen";
import BusinessDetailsScreen from "./screens/organisation-business-details/business-details-screen";
import MerchantProfileDetailsScreen from "./screens/merchant-profile/merchant-profile";
// import MerchantKYCDetailsScreen from "./screens/merchant-kyc/merchant-kyc-screen";
import MerchantBasicDetailsScreen from "./screens/merchant-basic-details/merchant-basic-details";
import CreateNewTripPage from "../src/screens/create-new-trip/create-new-trip";
import TripsCreated from "./screens/trips-created/trip-created";
// import SlotWiseBookingScreen from "./screens/slotwise-booking-screen/slotwise-booking-screen";
import BookingDetails from "./screens/individual-booking/individual-booking";
import ForgetPassword from "../src/screens/forget-password/forget-password";
import PrivateRoute from "PrivateRoute";
import ErrorBoundary from "Error";
import { Suspense } from "react";
import Loader from "components/shared/loader/loader";
import NotFound from "NotFound";
import Support from "screens/support/support";
import VendorAgreement from "screens/merchant-vendor-agreement/vendor-agreement";

function App() {
  return (
    <ThemeProvider theme={appTheme}>
      <BrowserRouter>
        <ErrorBoundary>
          <Suspense fallback={<Loader />}>
            <Routes>
              <Route path="/" element={<SignUpScreen />} />
              <Route path="/signIn" element={<SignInScreen />} />
              <Route path="/forget-password" element={<ForgetPassword />} />
              <Route element={<PrivateRoute restricted={false} />}>
                <Route path="/home" element={<HomeScreen />} />
                {/* <Route
                  path="/profile-details"
                  element={<ProfileDetailsScreen />}
                /> */}
                <Route
                  path="/organisation-business-details"
                  element={<BusinessDetailsScreen />}
                />
                {/* <Route
                  path="/merchant-kyc-details"
                  element={<MerchantKYCDetailsScreen />}
                /> */}
                <Route
                  path="/merchant-basic-details"
                  element={<MerchantBasicDetailsScreen />}
                />
                <Route
                  path="/merchant-profile-details"
                  element={<MerchantProfileDetailsScreen />}
                />
                <Route path="/vendor-agreement" element={<VendorAgreement />} />
                <Route path="/bank-details" element={<BankDetailsScreen />} />
                <Route path="/kyc" element={<KYCDetailsScreen />} />
                <Route path="/basic-details" element={<BasicDetailsScreen />} />
                <Route path="/support" element={<Support />} />
              </Route>

              <Route element={<PrivateRoute restricted={true} />}>
                <Route
                  path="/create-new-trips"
                  element={<CreateNewTripPage />}
                />
                <Route path="/trips-created" element={<TripsCreated />} />
                {/* <Route
                  path="/slotwise-booking"
                  element={<SlotWiseBookingScreen />}
                /> */}
                <Route path="/trip-reviews" element={<TripReviewsScreen />} />
                <Route path="/individual-booking" element={<BookingDetails />} />
                <Route path="/memories-list" element={<ShortsScreen />} />
              </Route>
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Suspense>
        </ErrorBoundary>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
